import { Channel } from '@at/sauron-platform-core'
import { ChannelSearchTypeKey } from '../../utils/channel-utilities'

export const defaultChannelFilterOrder: Map<ChannelSearchTypeKey, string[]> = new Map()

defaultChannelFilterOrder.set(Channel.cars, [
    'sort',
    'distance',
    'category_tag',
    'make_and_model',
    'digital_retailing',
    'price',
    'year',
    'mileage',
    'gearbox',
    'body_type',
    'colour',
    'doors',
    'seats',
    'fuel_type',
    'battery_range',
    'charging_time',
    'engine_size',
    'engine_power',
    'acceleration',
    'fuel_consumption',
    'co2_emissions',
    'tax_per_year',
    'insurance_group',
    'drive_type',
    'boot_space',
    'seller_type',
    'previously_written_off',
    'keyword_search',
    'manufacturer_approved',
    'include_ni_only',
])
defaultChannelFilterOrder.set('cars-leasing', [
    'sort',
    'lease_product_type',
    'lease_in_stock',
    'price',
    'make_and_model',
    'body_type',
    'seats',
    'fuel_type',
    'battery_range',
    'charging_time',
    'gearbox',
    'engine_size',
    // 'doors',
    // 'engine_power',
    // 'acceleration',
    // 'fuel_consumption',
    // 'co2_emissions',
    // 'insurance_group',
    // 'drive_type',
    // 'boot_space',
    // 'keyword_search',
])
defaultChannelFilterOrder.set(Channel.cycles, [
    'sort',
    'distance',
    'make_and_model',
    'style',
    'frame_size_cm',
    'price',
    'colour',
    'keyword_search',
])
defaultChannelFilterOrder.set(Channel.vans, [
    'sort',
    'distance',
    'make_and_model',
    'digital_retailing',
    'price',
    'vat_status',
    'year',
    'mileage',
    'body_type',
    'gearbox',
    'wheelbase',
    'fuel_type',
    'colour',
    'seats',
    'doors',
    'cab_type',
    'engine_size',
    'engine_power',
    'fuel_consumption',
    'co2_emissions',
    'seller_type',
    'previously_written_off',
    'keyword_search',
    'manufacturer_approved',
    'include_ni_only',
])

defaultChannelFilterOrder.set('vans-leasing', [
    'sort',
    'lease_product_type',
    'lease_in_stock',
    'price',
    'make_and_model',
    'body_type',
    'seats',
    'cab_type',
    'wheelbase',
    'fuel_type',
    'gearbox',
    'engine_size',
])

defaultChannelFilterOrder.set(Channel.bikes, [
    'sort',
    'distance',
    'make_and_model',
    'engine_size_cc',
    'engine_power',
    'price',
    'year',
    'body_type',
    'mileage',
    'fuel_type',
    'colour',
    'seller_type',
    'previously_written_off',
    'keyword_search',
    'manufacturer_approved',
])
defaultChannelFilterOrder.set(Channel.trucks, [
    'sort',
    'distance',
    'make_and_model',
    'style',
    'body_type',
    'year',
    'price',
    'axle_config',
    'gross_vehicle_weight',
    'gearbox',
    'fuel_type',
    'engine_power',
    'emission_class',
    'cab_type',
    'mileage_km',
    'driver_position',
    'keyword_search',
])
defaultChannelFilterOrder.set(Channel.farm, [
    'sort',
    'distance',
    'make_and_model',
    'style',
    'year',
    'price',
    'hours_used',
    'keyword_search',
])
defaultChannelFilterOrder.set(Channel.plant, [
    'sort',
    'distance',
    'make_and_model',
    'style',
    'year',
    'price',
    'hours_used',
    'keyword_search',
])
defaultChannelFilterOrder.set(Channel.caravans, [
    'sort',
    'distance',
    'make_and_model',
    'price',
    'berth',
    'year',
    'style',
    'trailer_axle_number',
    'bedroom_layout',
    'end_layout',
    'mtplm',
    'exterior_length',
    'seller_type',
    'keyword_search',
])
defaultChannelFilterOrder.set(Channel.motorhomes, [
    'sort',
    'distance',
    'make_and_model',
    'price',
    'year',
    'berth',
    'gearbox',
    'mileage',
    'exterior_length',
    'body_type',
    'fuel_type',
    'engine_size',
    'seats_range',
    'driver_position',
    'end_layout',
    'bedroom_layout',
    'seller_type',
    'previously_written_off',
    'keyword_search',
])
